<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Create Quiz</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div style="width: 100%" class="mt-3">
        <CCol sm="12">
          <span class="mt-5 mb-5"> </span>
          <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
        </CCol>
      </div>
    </div>
    <CCard class="custom-card h-100">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <h4 class="text-left mt-4 mb-4 d-flex d-sm-none text-black bold"
                style="
                  font-size:30px; 
                  font-family:Helvetica;
                  color:#3d3d5c;                  
                  ">
                <strong>Quiz Preview</strong>
              </h4>

              <CCard style="
                background-color: #e6f0ff;
                border-radius:10%;
                " class="mb-3">
                <CRow class="text-left mt-4 d-flex d-sm-none col-12" style="font-size:15px">
                  <CCol class="col-1">
                    <img src="../assets/img/subjects.png" width="20px" height="20px" />
                  </CCol>
                  <CCol class="col-4">
                    <strong>Subject</strong>
                  </CCol>
                  <CCol class="col-7">
                    <strong>:{{ qSummary.subjectName }}</strong>
                  </CCol>
                </CRow>

                <CRow class="text-left mt-3 d-flex d-sm-none col-12" style="font-size:15px">
                  <CCol class="col-1">
                    <img src="../assets/img/grade.png" width="20px" height="20px" />
                  </CCol>
                  <CCol class="col-4">                  
                    <strong>Grade</strong>
                  </CCol>
                  <CCol class="col-7">
                    <strong>:{{ qSummary.gradeName }}</strong>
                  </CCol>
                </CRow>

                <CRow class="text-left mt-3 d-flex d-sm-none col-12" style="font-size:15px">
                  <CCol class="col-1">
                    <img src="../assets/img/title.png" width="20px" height="20px" />
                  </CCol>
                  <CCol class="col-4">
                    <strong>Title</strong>
                  </CCol>
                  <CCol class="col-7">
                    <strong>:{{ qSummary.Title }}</strong>
                  </CCol>
                </CRow>

                <CRow class="text-left mt-3 d-flex d-sm-none col-12" style="font-size:15px">
                  <CCol class="col-1">
                    <img src="../assets/img/questionamt.png" width="20px" height="20px" />
                  </CCol>
                  <CCol class="col-4">
                    <strong>Question Amount</strong>
                  </CCol>
                  <CCol class="col-7">
                    <strong>:{{ qSummary.questionCount }}</strong>
                  </CCol>
                </CRow>

                <CRow class="text-left mt-3 d-flex d-sm-none col-12" style="font-size:15px">
                  <CCol class="col-1">
                    <img src="../assets/img/timer.png" width="20px" height="20px" />
                  </CCol>
                  <CCol class="col-4">
                    <strong>Timer</strong>
                  </CCol>
                  <CCol class="col-7">
                    <strong>:{{ qSummary.TimerString }}</strong>
                  </CCol>
                </CRow>

                <CRow class="text-left mt-3 d-flex d-sm-none col-12" style="font-size:15px">
                  <CCol class="col-1">
                    <img src="../assets/img/createdby.png" width="20px" height="20px" />
                  </CCol>
                  <CCol class="col-4">
                    <strong>Created By</strong>
                  </CCol>
                  <CCol class="col-7">
                    <strong>:{{ qSummary.TeacherName }}</strong>
                  </CCol>
                </CRow>

                <CRow class="text-left mt-3 mb-4 d-flex d-sm-none col-12" style="font-size:15px">
                  <CCol class="col-1">
                    <img src="../assets/img/publish.png" width="20px" height="20px" />
                  </CCol>
                  <CCol class="col-4">
                    <strong>Publish Date</strong>
                  </CCol>
                  <CCol class="col-7">
                    <strong>:{{ qSummary.CreatedDate | moment("DD MMM YYYY") }}</strong>
                  </CCol>
                </CRow>
              </CCard>

              <br />
              <div>
                <CButton
                  color="success"
                  class="custom-btn mt-1 mb-4"
                  size="lg"
                  block
                  :disabled="isDisabled"
                  @click="GoToDashBoard"
                  >Close</CButton
                >
              </div>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
  </div>

  <!--gg  -->
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";

import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader
  },
  data() {
    return {
      backgroundBanner,
      qSummary:{},
      SubmittedForm: false,
      Error: false
    };
  },
  async mounted() {
    this.GetQuizPreview();
  },
  computed: {},
  methods: {
    //Get quiz summary
    async GetQuizPreview() {
      return this.$API
        .get(
          this.$QuizPreview + 
          "?quizId=" + 
          this.$route.query.quizId,
          {
          withCredentials: true
          })
          .then(response => {
            if (response.status == 200 && response.data != null) {
            this.qSummary = response.data;
            console.log(this.qSummary);
            }
          })
        .catch(function(error) {
          console.log(error.response);
        });
    },
    
    GoToDashBoard() {
      this.$router.push(
        "/QuizTeacherDashboard?userId=" + this.$route.query.userId
      );
    }
  }
};
</script>

<style>
.lines {
  width: 100%;
  height: 45px;
  position: relative;
}

.lines::after,
.lines::before {
  content: "";
  position: absolute;
  margin: auto;
  height: 2px;
  background: rgb(201, 32, 32);
  width: 45%;
  top: 45%;
}

.lines::after {
  left: 0;
}

.lines::before {
  right: 0;
}

.word {
  height: 50px;
  width: 50px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  padding-top: 8px;
  font-size: 15px;
}
.inputbox {
  border: 1px solid black;
  padding-left: 0;
  padding-right: 0;
  text-align: center;
  height: 150px;
}
#myfile {
  padding-left: 100px;
  padding-top: 40px;
}

#fb-root{
  display:none;
}
</style>
